var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.558 4.31v7.706a.984.984 0 11-1.968 0V4.21L3.754 6.047a.984.984 0 11-1.391-1.392L5.69 1.327a.98.98 0 01.606-.284.984.984 0 011.012.236l3.328 3.329a.984.984 0 11-1.39 1.39L7.556 4.31z"
  })));
}
export default SvgSortUp;